<template>
  <div
    class="scheduled-at-field"
    :class="{ 'scheduled-at-field--compact-tz': compactTimezone }"
  >
    <div v-if="label" class="scheduled-at-field__label-row">
      <span class="scheduled-at-field__label">{{ label }}</span>
      <FcTooltip
        v-if="compactTimezone"
        class="scheduled-at-field__help scheduled-at-field__help--label"
        variant="rich"
      >
        <v-icon small>mdi-help-circle-outline</v-icon>
        <template #content>
          <NotificationNextRunsTooltip :schedule="previewSchedule" />
        </template>
      </FcTooltip>
    </div>
    <div class="scheduled-at-field__row">
      <div class="scheduled-at-field__time">
        <lb-time
          hide-label
          readonly
          :value="value"
          :error="error"
          :hidedetails="!error"
          :disabled="disabled"
          :data-testid="dataTestid + '__input'"
          @input="$emit('input', $event)"
        />
      </div>
      <span
        v-if="!compactTimezone"
        class="scheduled-at-field__tz"
        :data-testid="dataTestid + '__tz'"
      >{{ timezoneSuffix }}</span>
      <FcTooltip
        v-if="!compactTimezone"
        class="scheduled-at-field__help"
        variant="rich"
      >
        <v-icon small>mdi-help-circle-outline</v-icon>
        <template #content>
          <NotificationNextRunsTooltip :schedule="previewSchedule" />
        </template>
      </FcTooltip>
    </div>
  </div>
</template>

<script>
import FcTooltip from '../../FcTooltip/FcTooltip.vue';
import NotificationNextRunsTooltip from '../NotificationNextRunsTooltip/NotificationNextRunsTooltip.vue';
import {
  browserTimezoneShortLabel,
  buildSchedulePayload,
} from '../../../utils/notificationScheduleUtils';

export default {
  name: 'ScheduledAtField',
  components: { FcTooltip, NotificationNextRunsTooltip },
  props: {
    value: { type: String, default: '09:00' },
    label: { type: String, default: 'Scheduled at' },
    error: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    dataTestid: { type: String, default: 'scheduled-at-field' },
    /** Hide inline timezone line; use in fc-notification-form beside other 40px controls. */
    compactTimezone: { type: Boolean, default: false },
  },
  computed: {
    previewSchedule() {
      return buildSchedulePayload({ startTime: this.value });
    },
    timezoneSuffix() {
      return browserTimezoneShortLabel();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './ScheduledAtField.scss';
</style>
